import React, { Component } from 'react';
import { Modal, Input, message } from 'antd';
import JSEncrypt from 'jsencrypt';
import './ForgetPassword.styl';
import {
  resetPassword,
  sendVerificationCode,
  graphicVerificationCode,
  getPublicKey,
} from '@/api/login';

export default class ForgetPassword extends Component {
  state = {
    email: '',
    verificationCode: '',
    confirmLoading: false,
    count: 60, // 倒计时
    liked: true,
    code: '',
    captchaCode: '',
    uuid: '',
    newPassword: '',
    confirmNewPassword: '',
  };

  render() {
    const {
      confirmLoading,
      email,
      verificationCode,
      count,
      liked,
      captchaCode,
      code,
      newPassword,
      confirmNewPassword,
    } = this.state;
    return (
      <div className="forget-password">
        <Modal
          title="重置密码"
          visible={this.props.visible}
          width={600}
          className="forget-password-modal"
          confirmLoading={confirmLoading}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <div className="flex-row-start-center">
            <span style={{ width: '118px' }}>企业邮箱：</span>
            <Input
              placeholder="请输入企业邮箱"
              addonAfter="@ruigushop.com"
              value={email}
              onChange={(e) => this.changeFiled(e, 'email')}
            />
          </div>
          <div className="flex-row-start-center m-t-15">
            <span style={{ width: '118px' }}>数字校验码：</span>
            <Input
              className="input-back"
              placeholder="请输入数字校验码"
              addonAfter={
                <img
                  src={captchaCode}
                  alt=""
                  className="captcha-code"
                  onClick={() => this.getCaptchaCode()}
                />
              }
              value={code}
              onChange={this.changeCaptchaCode}
            />
          </div>
          <div className="flex-row-start-center m-t-15">
            <span style={{ width: '118px' }}>邮箱验证码：</span>
            <Input
              disabled={!email || !code}
              placeholder="请输入邮箱验证码"
              addonAfter={
                <span className='pointer' onClick={this.sendCode.bind(this)}>
                  {liked ? '获取验证码' : `${count} s`}
                </span>
              }
              value={verificationCode}
              onChange={(e) => this.changeFiled(e, 'verificationCode')}
            />
          </div>
          <div className="flex-row-start-center m-t-15">
            <span style={{ width: '118px' }}>新密码：</span>
            <Input.Password
              value={newPassword}
              placeholder="请输入密码"
              onChange={(e) => this.changeFiled(e, 'newPassword')}
            />
          </div>
          <div className="flex-row-start-center m-t-15">
            <span style={{ width: '118px' }}>确认新密码：</span>
            <Input.Password
              value={confirmNewPassword}
              placeholder="请确认密码"
              onChange={(e) => this.changeFiled(e, 'confirmNewPassword')}
            />
          </div>
        </Modal>
      </div>
    );
  }

  async getCaptchaCode() {
    try {
      const { uuid, image: captchaCode } = await graphicVerificationCode();
      this.setState({
        captchaCode,
        uuid,
      });
    } catch (e) {
      message.warning(e.message || '');
    }
  }

  // 防水码
  changeCaptchaCode = ({ target: { value } }) => {
    this.setState({
      code: value,
    });
  };

  async sendCode() {
    const { liked, email, code } = this.state;
    if (!liked || !email || !code) {
      return;
    }
    try {
      this.countDown();
      const res = await sendVerificationCode({
        email: this.state.email + '@ruigushop.com',
        graphVerifyCode: code,
        uuid: this.state.uuid,
      });
      if (res.result) {
        message.info('验证码已经发送到您的邮箱！');
      }
    } catch (error) {
      this.getCaptchaCode();
      message.warning(error.message || `验证码发送失败`);
    }
  }

  // 倒计时
  countDown() {
    const { count } = this.state;
    if (count === 1) {
      this.setState({
        count: 60,
        liked: true,
      });
    } else {
      this.setState({
        count: count - 1,
        liked: false,
      });
      setTimeout(this.countDown.bind(this), 1000);
    }
  }

  // 改变email/验证码
  changeFiled = ({ target: { value } }, filed) => {
    this.setState({
      [filed]: value,
    });
  };

  handleOk = async () => {
    if (this.state.email === '') {
      message.warning('请输入企业邮箱！');
      return;
    }
    if (!this.state.verificationCode) {
      message.warning('请输入验证码！');
      return;
    }
    if (!this.state.newPassword) {
      message.warning('请输入密码！');
      return;
    }
    if (!this.state.confirmNewPassword) {
      message.warning('请输入确认密码！');
      return;
    }
    if (this.state.confirmNewPassword !== this.state.newPassword)  {
      message.warning('请检验密码，两次输入不一致！');
      return;
    }
    // 加密
    const publicKey = await getPublicKey();
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKey);
    const newPassword = encryptor.encrypt(this.state.newPassword);
    this.setState({ confirmLoading: true });
    resetPassword({
      email: this.state.email + '@ruigushop.com',
      verificationCode: this.state.verificationCode,
      newPassword,
      publicKey,
    })
      .then((res) => {
        this.props.handleCloseModal(false);
        message.success(res || '密码已重置');
        this.getCaptchaCode();
        this.setState({
          confirmLoading: false,
          email: '',
          verificationCode: '',
          code: '',
        });
      })
      .catch((err) => {
        this.setState({ confirmLoading: false });
        this.getCaptchaCode();
        message.warning(err.message);
      });
  };
  handleCancel = () => {
    this.props.handleCloseModal(false);
    this.setState({
      email: '',
      code: '',
      verificationCode: '',
      newPassword: '',
      confirmNewPassword: '',
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      this.getCaptchaCode();
    }
  }
}
